<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.743 17.749a.842.842 0 0 0 0-1.208l-4.504-4.418a.17.17 0 0 1 0-.247l4.504-4.418a.84.84 0 0 0 0-1.208.887.887 0 0 0-1.235 0L9.26 11.396a.835.835 0 0 0 0 1.207l5.248 5.146a.88.88 0 0 0 1.235 0Z"
      fill="currentColor"
    />
  </svg>
</template>
